/* erx-lp.js - landing pages (sections/erx-lp-*). Only behaviour: a "Žiūrėti video" pill opens the assembly
   film in a lightbox (nothing is loaded until it is asked for). Pill markup:
   <button data-erx-lp-video="<mp4 url>" data-poster="<jpg url>" data-close="<label>">…</button> */
(function () {
  'use strict';
  var box = null, vid = null, last = null;
  function close() {
    if (!box) return;
    try { vid.pause(); } catch (e) {}
    vid.removeAttribute('src'); vid.load();
    box.hidden = true;
    document.documentElement.classList.remove('erx-lp-lb-open');
    if (last) { try { last.focus({ preventScroll: true }); } catch (e) {} }
  }
  function open(btn) {
    last = btn;
    if (!box) {
      box = document.createElement('div');
      box.className = 'erx-lp erx-lp-lb';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.innerHTML = '<div class="erx-lp-lb__in"><video class="erx-lp-lb__v" controls playsinline preload="none"></video>' +
        '<button type="button" class="erx-lp-lb__x"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
      document.body.appendChild(box);
      vid = box.querySelector('video');
      box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('.erx-lp-lb__x')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box && !box.hidden) close(); });
    }
    box.querySelector('.erx-lp-lb__x').setAttribute('aria-label', btn.getAttribute('data-close') || '×');
    box.setAttribute('aria-label', btn.textContent.trim());
    if (btn.getAttribute('data-poster')) vid.setAttribute('poster', btn.getAttribute('data-poster'));
    vid.src = btn.getAttribute('data-erx-lp-video');
    box.hidden = false;
    document.documentElement.classList.add('erx-lp-lb-open');
    box.querySelector('.erx-lp-lb__x').focus({ preventScroll: true });
    var p = vid.play(); if (p && p.catch) p.catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-erx-lp-video]');
    if (!b) return;
    e.preventDefault();
    open(b);
  });
})();
